"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _palette = require("./palette");

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const buttons = {
  green: {
    color: _palette2.default.white.normal,
    backgroundColor: _palette2.default.green["600"],
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.green["700"]
    },
    "&:active": {
      backgroundColor: _palette2.default.green["800"]
    },
    "svg > path": {
      fill: _palette2.default.white.normal
    }
  },
  blue: {
    color: _palette2.default.white.normal,
    backgroundColor: _palette2.default.blue["600"],
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.blue["700"]
    },
    "&:active": {
      backgroundColor: _palette2.default.blue["800"]
    },
    "svg > path": {
      fill: _palette2.default.white.normal
    }
  },
  orange: {
    color: _palette2.default.white.normal,
    backgroundColor: _palette2.default.orange["600"],
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.orange["700"]
    },
    "&:active": {
      backgroundColor: _palette2.default.orange["800"]
    },
    "svg > path": {
      fill: _palette2.default.white.normal
    }
  },
  ink: {
    color: _palette2.default.ink["700"],
    backgroundColor: _palette2.default.ink["100"],
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.ink["200"]
    },
    "&:active": {
      backgroundColor: _palette2.default.ink["300"]
    },
    "svg > path": {
      fill: _palette2.default.ink["700"]
    }
  },
  red: {
    color: _palette2.default.white.normal,
    backgroundColor: _palette2.default.red["700"],
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.red["800"]
    },
    "&:active": {
      backgroundColor: _palette2.default.red["900"]
    },
    "svg > path": {
      fill: _palette2.default.white.normal
    }
  },
  blueBordered: {
    color: _palette2.default.blue["700"],
    border: `1px solid ${_palette2.default.blue["600"]}`,
    backgroundColor: _palette2.default.white.normal,
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.blue["000"]
    },
    "&:active": {
      backgroundColor: _palette2.default.ink["300"]
    },
    "svg > path": {
      fill: _palette2.default.blue["700"]
    }
  },
  redBordered: {
    color: _palette2.default.red["700"],
    border: `1px solid ${_palette2.default.red["600"]}`,
    backgroundColor: _palette2.default.white.normal,
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.red["000"]
    },
    "&:active": {
      backgroundColor: _palette2.default.ink["300"]
    },
    "svg > path": {
      fill: _palette2.default.red["700"]
    }
  },
  greenBordered: {
    color: _palette2.default.green["600"],
    border: `1px solid ${_palette2.default.green["600"]}`,
    backgroundColor: _palette2.default.white.normal,
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.green["000"]
    },
    "&:active": {
      backgroundColor: _palette2.default.ink["300"]
    },
    "svg > path": {
      fill: _palette2.default.green["600"]
    }
  },
  orangeBordered: {
    color: _palette2.default.orange["600"],
    border: `1px solid ${_palette2.default.orange["600"]}`,
    backgroundColor: _palette2.default.white.normal,
    "&:focus": {
      outline: 0,
      boxShadow: "none !important"
    },
    "&:hover": {
      backgroundColor: _palette2.default.orange["000"]
    },
    "&:active": {
      backgroundColor: _palette2.default.ink["300"]
    },
    "svg > path": {
      fill: _palette2.default.orange["600"]
    }
  },
  disabled: {
    pointerEvents: "none"
  }
};
exports.default = buttons;